/**
 * UploadedBy Value Object
 * Represents the user who uploaded a PASCO
 */
export interface UploadedBy {
    userId: string;
    name: string;
    profilePicture: string | null;
}

/**
 * Factory function to create UploadedBy value object
 */
export function createUploadedBy(userId: string, name: string, profilePicture: string | null = null): UploadedBy {
    return {
        userId,
        name,
        profilePicture,
    };
}
